import React, {useEffect} from 'react';
import { Helmet } from 'react-helmet-async';
import {Metadata} from "@/models/cms/Metadata";
import {ApiProvider} from "@reapptor-apps/reapptor-react-common";
import {DynamicPageResponseSingleType} from "@/models/cms/DynamicPageResponse";
function MetaTags  ({ pageName = '', title = '', description = '' }) {
    const [metaData, setMetaData] = React.useState<Metadata | null>(null);

    useEffect(() => {
        const getMetadata = async (pageName: string) => {
            const metaData: DynamicPageResponseSingleType = await ApiProvider.getAsync(`/api/Application/GetMetadata?pageName=${pageName}`, null);
            if(metaData && (metaData.data.attributes.metadataPairs
                && metaData.data.attributes.metadataPairs.length > 0
                && (metaData.data.attributes.metadataPairs[0].title || metaData.data.attributes.metadataPairs[0].description))) {
                setMetaData(metaData.data.attributes.metadataPairs[0]);
            }
        }
        
        if(pageName){
            getMetadata(pageName)
        }
        else if (title || description){
            setMetaData({title: title ?? '', description: description ?? ''})
        }
        
    }, []);
    
    return (
        <Helmet>
                { /* Standard metadata tags */}
                <title>{metaData?.title}</title>
                <link rel='canonical' href={window.location.href}/>
                <meta name='description' content={metaData?.description}/>
                { /* Open Graph tags (OG) */}
                <meta property="og:url" content={window.location.href}/>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content={metaData?.title}/>
                <meta property="og:description" content={metaData?.description}/>
                {/* OG image tags */}
                {/*<meta property="og:image" content={image}/>
                <meta property="og:image:secure_url" content={image}/>*/}
                <meta property="og:image:type" content="image/jpeg"/>
                <meta property="og:image:width" content="200"/>
                <meta property="og:image:alt" content={`Image of ${metaData?.title} site`}/>
                { /* Twitter tags */}
                {/*<meta name="twitter:creator" content={name}/>*/}
                <meta name="twitter:card" content="summary"/>
                <meta name="twitter:title" content={metaData?.title}/>
                <meta name="twitter:description" content={metaData?.description}/>
        </Helmet>
    );
}

export default MetaTags;